"use strict";
function updateWindowSize() {
    document.getElementsByTagName('html')[0].dataset.windowSize =
        window.innerWidth >= 1200 ? 'large' : 'small';
}
window.addEventListener('resize', updateWindowSize);
updateWindowSize();
